export const pickWinnerSection = (payload: unknown) => {
  try {
    if (
      payload &&
      typeof payload === "object" &&
      "section" in payload &&
      payload.section &&
      typeof (payload as any).section === "object"
    ) {
      const s = (payload as any).section;
      if (typeof s.id === "string") {
        return s;
      }
    }
  } catch {
    // ignore
  }
  return null;
};

type Params = {
  isAuthenticated: boolean | null;
  currency?: string | null;
  id?: number | string | null;
  firstDeposit?: boolean | null;
};

const isBDTCurrency = (cur?: string | null) => {
  const v = (cur ?? "").toString().trim().toUpperCase();
  return v === "BDT";
};

const isEvenUserId = (id?: number | string | null) => {
  if (id === null || id === undefined) {
    return false;
  }
  const n = typeof id === "number" ? id : parseInt(String(id), 10);
  if (!Number.isFinite(n)) {
    return false;
  }
  return Math.abs(n) % 2 === 0;
};

export function shouldShowFortuneWheel(params: Params): boolean {
  const { isAuthenticated, currency, id, firstDeposit } = params;
  if (!isAuthenticated) {
    return false;
  }
  if (!isBDTCurrency(currency)) {
    return false;
  }
  if (!isEvenUserId(id)) {
    return false;
  }
  return !!firstDeposit;
}
